export const WeaponImage = ({weapon, sillhouette = false, style, shadow = !sillhouette}) => {
    try {
        return weapon ? <img
            src={require(`../assets/weapons/${sillhouette ? 'outline/' : ''}${weapon.toLowerCase().replaceAll(' ', '-').replaceAll('.', '')}.png`)}
            alt={weapon} style={{...style, filter: shadow ? 'drop-shadow(0px 0px 6px rgba(0,0,0,0.75)' : 'none'}}/> : null
    } catch (e) {
        console.log(e)
    }
}